import {
    GET_ADV_CAMPAIGNS_LOADING,
    GET_ADV_CAMPAIGNS_SUCCESS

} from '../actions/AdvCampaignsActions';

const initialState = {
    advCampaignData: null,
    isLoading: true,
};

const AdvCampaignReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_ADV_CAMPAIGNS_SUCCESS:
            return { ...state, advCampaignData: action.data, isLoading: false };

        case GET_ADV_CAMPAIGNS_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default AdvCampaignReducer;
